import { useEffect } from "react";

/**
 * Set document.title for the current route.
 * Reverts to default ('بَلاغة — معلّم البلاغة العربيّة') on unmount.
 */
const DEFAULT_TITLE = "بَلاغة — معلّم البلاغة العربيّة";

export default function usePageTitle(title) {
  useEffect(() => {
    if (title) document.title = title;
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
